import { CommanderFunction } from "../contexts/commander";
import { GameName } from "inbox-contentful";

export function openShopOffer({
    game,
    eventId,
    sendCommand,
}: {
    game: GameName;
    eventId: string;
    sendCommand: CommanderFunction;
}) {
    const id = `milestone-chronos-${eventId}`;

    switch (game) {
        case "squadbusters":
            sendCommand("GAME_COMMAND", {
                url: `Offer?event_id=${eventId}`,
                id,
                label: "OpenShopOffer",
            });
            break;
        case "rogue":
            sendCommand("GAME_COMMAND", {
                url: `OpenShopOfferBundle/${eventId}`,
                id,
                label: "OpenShopOfferBundle",
            });
            break;
        default:
            break;
    }
}
